import { useEffect, useState } from 'react'
import EformMultiSelectCheckbox from '@/components/EformMultiSelectCheckbox/index'
import PropTypes from 'prop-types'

/**
 * Alias for cell-multiselect.jsx — EFormFieldDictionary maps 'multi-select' to this file.
 * Ported from pitstop-ui/src/components/EForm/FormField/cell-multi-select.jsx
 */

const CellMultiSelectComponent = ({
  isReadOnly,
  schema,
  payload,
  parentProps,
  inputProps,
  setInputProps,
  updatePayload,
  validateSchema,
  getFieldValue,
}) => {
  const [multiSelectLists, setMultiSelectLists] = useState([])

  useEffect(() => {
    const filledValue = getFieldValue(payload, parentProps)
    const rawOptions = schema['x-uioptions']
    const uiOptions = Array.isArray(rawOptions) ? rawOptions : rawOptions?.options
    const formatedList = Array.isArray(uiOptions)
      ? uiOptions.map(list => ({ ...list, $selected: filledValue?.includes(list.value) }))
      : []
    setMultiSelectLists(formatedList)
  }, [payload])

  function updateMultiSelectLists(multiSelectLists) {
    const updatedItem = multiSelectLists
      .filter(field => field.$selected === true)
      .map(filter => filter.value)
    setInputProps({ ...inputProps, updatedItem })
    updatePayload(updatedItem)
    validateSchema(updatedItem)
  }

  useEffect(() => {
    setInputProps({
      ...inputProps,
      disabled: isReadOnly,
      value: getFieldValue(payload, parentProps),
    })
  }, [payload])

  return (
    <EformMultiSelectCheckbox
      items={multiSelectLists}
      onChangeFunc={updateMultiSelectLists}
      placeholder={isReadOnly ? null : 'Select Option'}
      disable={isReadOnly}
    />
  )
}

CellMultiSelectComponent.propTypes = {
  isReadOnly: PropTypes.bool,
  schema: PropTypes.object,
  payload: PropTypes.object,
  parentProps: PropTypes.array,
  inputProps: PropTypes.object,
  setInputProps: PropTypes.func,
  updatePayload: PropTypes.func,
  validateSchema: PropTypes.func,
  getFieldValue: PropTypes.func,
}

export default CellMultiSelectComponent
